import shuffle from 'lodash-es/shuffle';

// get results from Algolia
const truncateString = (str, max, suffix) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;

const demoteHalfYearCourses = (items) => {
    let demotedHits = [];
    let elevatedHitsTemp = [];
    items.forEach((item) => {
        if (item.course_type === 'half') {
            demotedHits.push(item);
        } else {
            elevatedHitsTemp.push(item);
        }
    });
    return elevatedHitsTemp.concat(demotedHits);
};

const mergeElevatedHits = (result, elevatedHits, ordinaryHits) => {
    elevatedHits = shuffle(elevatedHits);
    // ordinaryHits = shuffle(ordinaryHits);
    if (elevatedHits.length > 0 && elevatedHits[0].type === 'course') {
        elevatedHits = demoteHalfYearCourses(elevatedHits);
    }
    if (ordinaryHits.length > 0 && ordinaryHits[0].type === 'course') {
        ordinaryHits = demoteHalfYearCourses(ordinaryHits);
    }
    return result.concat(elevatedHits, ordinaryHits);
};

const getResults = async (client, lang, queryString, queryType) => {
    const requestOptions = {
        indexName: 'fhs',
        query: queryString,
        hitsPerPage: 1000,
        attributesToRetrieve: [
            'title',
            'teaser',
            'url',
            'school',
            'course_type'
        ],
        attributesToHighlight: [
            'title',
            'teaser'
        ],
        typoTolerance: 'min',               // ↓ make typo tolerance stricter
        exactOnSingleWordQuery: 'word',     // ↓ prioritize exact matches like "Evje"
        removeWordsIfNoResults: 'none',     // ↓ prevents partial fallbacks
        ignorePlurals: false,               // ↓ keeps plural handling off (useful in Norwegian)
    };

    if (lang === 'en') {
        requestOptions['attributesToRetrieve'] = [
            'title',
            'title_en',
            'teaser',
            'teaser_en',
            'url',
            'school',
            'course_type'
        ];
        requestOptions['restrictSearchableAttributes'] = [
            'title_en',
            'teaser_en',
            'school'
        ];
        // set highlight attributes
    }

    const response = await client.search({
        requests: [requestOptions],
    });

    const hits = response.results[0].hits;
    const typeRegex = /\\([^\\:]+):/;

    let result = [];
    let resultTemp = [];
    let elevatedResultTemp = [];

    let currentElevationType = null;

    for (let key in hits) {
        let elevatedResult = false;
        let hit = hits[key];
        // truncate teaser text:
        if (hit.teaser) {
            hit.teaser = truncateString(hit.teaser, 250, '...');
        } else {
            hit.teaser = '';
        }
        // get type key from object ID and add to search hit
        let typeMatches = typeRegex.exec(hit.objectID);
        if (typeMatches) {
            let typeName = typeMatches[1].toLowerCase();
            if (typeName === 'wordpresspost') {
                typeName = 'blog';
            }
            hit.type = typeName;
        } else {
            hit.type = '';
        }

        // highlight attributes
        if (hit._highlightResult.title) {
            hit.title = hit._highlightResult.title.value;
            if (hit._highlightResult.title.matchLevel === "full") {
                // elevate better matches in search result
                elevatedResult = true;
            }
        }
        // only add if the teaser was not truncated (do not mess with html tags)
        if (hit._highlightResult.teaser && !hit.teaser.endsWith('...')) {
            hit.teaser = hit._highlightResult.teaser.value;
        }

        if (lang === 'en') {
            if (hit._highlightResult.title_en) {
                hit.title = hit._highlightResult.title_en.value;
            } else if (hit.title_en) {
                hit.title = hit.title_en;
            }
            if (hit._highlightResult.teaser_en) {
                hit.title = hit._highlightResult.teaser_en.value;
            } else if (hit.teaser_en) {
                hit.title = hit.teaser_en;
            }
        }

        // shuffle following courses and schools, with elevation of exact hits
        if (!queryType || queryType === 'all' || hit.type === queryType) {
            if (queryType === 'school') {
                // avoid shuffling when only viewing schools
                result.push(hit);
                continue;
            }
            if (hit.type !== currentElevationType && (resultTemp.length || elevatedResultTemp.length)) {
                result = mergeElevatedHits(result, elevatedResultTemp, resultTemp);
                elevatedResultTemp = [];
                resultTemp = [];
                currentElevationType = null;
            }
            if (currentElevationType === null && (hit.type === 'course' || hit.type === 'school')) {
                currentElevationType = hit.type;
            }
            if (hit.type === currentElevationType) {
                if (elevatedResult) {
                    elevatedResultTemp.push(hit);
                } else {
                    resultTemp.push(hit);
                }
            } else {
                result.push(hit);
            }
        }
    }

    if (resultTemp.length || elevatedResultTemp.length) {
        result = mergeElevatedHits(result, elevatedResultTemp, resultTemp);
    }

    const totalHits = (!queryType || queryType === 'all') ? response.results[0].nbHits : result.length;

    return {
        result,
        totalHits
    };
};

export default getResults;